import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-21.73816, 166.177483, 13],
  [-21.738187, 166.177375, 13],
  [-21.738215, 166.177279, 13],
  [-21.738246, 166.177171, 13],
  [-21.738275, 166.177064, 13],
];

export default stream;
